import {
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import { Box } from "@mui/system";
import { Add, Delete, DeleteOutline } from "@mui/icons-material";
import {
    CerateNewVendor,
    resetVendors,
} from "../../Redux/VendorSlice/VendorSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";

const CreateVendor = () => {
    const dispatch = useDispatch();
    const { isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.vendors
    );
    const { states, isStateSuccess, isStateErorr, isStatesloading } =
        useSelector((state) => state.AllStates);

    // State Vendors Counts Of Create
    const stateVendorObj = {
        email: "",
        address: "",
        phone: "",
        state_id: "",
    };
    const [stateVendorFormQuantity, setstateVendorFormQuantity] = useState([
        stateVendorObj,
    ]);

    const handelAddNewState = () => {
        let data = stateVendorFormQuantity;
        data = [...stateVendorFormQuantity, stateVendorObj];
        setstateVendorFormQuantity(data);
    };

    const handelFormChange = (e, index) => {
        let data = [...stateVendorFormQuantity];
        data[index][e.target.name] = e.target.value;
        setstateVendorFormQuantity(data);
    };

    const handelDeleteForm = (e, index) => {
        let data = [...stateVendorFormQuantity];
        data.splice(index, 1);
        setstateVendorFormQuantity(data);
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success("Vendor created successfully");
            formik.values.name = "";
            setstateVendorFormQuantity([stateVendorObj]);
        }
    }, [isSuccess]);

    const AllStates = states?.data?.states;

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    const validationSchema = yup.object({});
    const formik = useFormik({
        initialValues: {
            name: "",
            // state_vendor: {},
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(
                CerateNewVendor({
                    name: values.name,
                    state_vendor: stateVendorFormQuantity,
                })
            );
            // await dispatch(resetVendors());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(resetVendors);
            };
            reset();
        }
    }, [isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add New Vendor </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={12}>
                                <FormHeading> Vendor States </FormHeading>
                                {stateVendorFormQuantity.map((state, index) => {
                                    return (
                                        <Card
                                            key={index}
                                            variant="outlined"
                                            mb={2}
                                            style={{ padding: "10px" }}
                                        >
                                            <Box>
                                                <Grid
                                                    mt={2}
                                                    container
                                                    columns={12}
                                                    spacing={3}
                                                >
                                                    <Grid
                                                        item
                                                        mb={1}
                                                        xs={12}
                                                        md={10}
                                                    >
                                                        <Grid
                                                            container
                                                            columns={12}
                                                            spacing={3}
                                                        >
                                                            <Grid
                                                                item
                                                                mb={1}
                                                                xs={12}
                                                                md={6}
                                                            >
                                                                <TextField
                                                                    fullWidth
                                                                    id="email"
                                                                    name="email"
                                                                    type="email"
                                                                    label="Email"
                                                                    value={
                                                                        state.email
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handelFormChange(
                                                                            e,
                                                                            index
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                mb={1}
                                                                xs={12}
                                                                md={6}
                                                            >
                                                                <TextField
                                                                    fullWidth
                                                                    id="phone"
                                                                    name="phone"
                                                                    type="phone"
                                                                    label="Phone"
                                                                    value={
                                                                        state.phone
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handelFormChange(
                                                                            e,
                                                                            index
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                mb={1}
                                                                xs={12}
                                                                md={6}
                                                            >
                                                                <TextField
                                                                    fullWidth
                                                                    id="address"
                                                                    name="address"
                                                                    type="address"
                                                                    label="Address"
                                                                    value={
                                                                        state.address
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handelFormChange(
                                                                            e,
                                                                            index
                                                                        )
                                                                    }
                                                                />
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                mb={1}
                                                                xs={12}
                                                                md={6}
                                                            >
                                                                <FormControl
                                                                    fullWidth
                                                                    required={
                                                                        true
                                                                    }
                                                                >
                                                                    <InputLabel id="demo-simple-select-label">
                                                                        State
                                                                    </InputLabel>
                                                                    <Select
                                                                        id="state_id"
                                                                        name="state_id"
                                                                        label="State"
                                                                        required
                                                                        value={
                                                                            state.state_id
                                                                        }
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            handelFormChange(
                                                                                e,
                                                                                index
                                                                            )
                                                                        }
                                                                    >
                                                                        {AllStates?.map(
                                                                            (
                                                                                key
                                                                            ) => (
                                                                                <MenuItem
                                                                                    key={
                                                                                        key.id
                                                                                    }
                                                                                    value={
                                                                                        key.id
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        key.name
                                                                                    }
                                                                                </MenuItem>
                                                                            )
                                                                        )}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        mb={1}
                                                        xs={12}
                                                        md={2}
                                                        sx={{
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            fullWidth
                                                            disableElevation
                                                            color="error"
                                                            sx={{
                                                                alignItems:
                                                                    "center",
                                                            }}
                                                            onClick={(e) =>
                                                                handelDeleteForm(
                                                                    e,
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            <Delete />
                                                            Delete
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Card>
                                    );
                                })}
                            </Grid>
                        </Grid>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1}>
                                <Button
                                    onClick={() => {
                                        handelAddNewState();
                                    }}
                                    variant="contained"
                                    color="success"
                                >
                                    <Add></Add>
                                    Add New State
                                </Button>
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add New Vendor"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateVendor;
